import {ModuleWithProviders, NgModule, NgModuleFactoryLoader} from "@angular/core";
import {ModuleLoaderService} from "./module-loader.service";

const globalComponents = new Map<string, Function>();

@NgModule({
  imports: [],
  providers: []
})
export class NSplitModule {

  static forRoot(): ModuleWithProviders<NSplitModule> {
    return {
      providers: [
        {
          provide: NgModuleFactoryLoader,
          useClass: ModuleLoaderService
        }
      ],
      ngModule: NSplitModule
    };
  }

}

export interface ISplitComponentDefinition {
  key: string;
  component: Function;
}

export function resolveGlobalComponent(key: string): any {
  return globalComponents.get(key);
}

export function registerSplitComponents(globals: ISplitComponentDefinition[]) {
  globals.forEach(def => globalComponents.set(def.key, def.component));
}
